import { render, staticRenderFns } from "./CompareItemsModal.vue?vue&type=template&id=7264ec73&scoped=true"
import script from "./CompareItemsModal.vue?vue&type=script&lang=js"
export * from "./CompareItemsModal.vue?vue&type=script&lang=js"
import style0 from "./CompareItemsModal.vue?vue&type=style&index=0&id=7264ec73&prod&lang=scss&scoped=true"
import style1 from "./CompareItemsModal.vue?vue&type=style&index=1&id=7264ec73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264ec73",
  null
  
)

export default component.exports